import { useEffect, useRef, useState } from "react";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Option as MultiSelectOption } from "./Option";
import "./styles.scss";

export interface MultiSelectOptionType {
  label: string;
  value: string;
}

interface MultiselectFilterProps {
  closePopover: () => void;
  currentFilter: string[];
  onChange: (value: string) => void;
  options: MultiSelectOptionType[];
}

export const MultiselectFilter = ({
  options = [],
  currentFilter = [],
  onChange,
  closePopover,
}: MultiselectFilterProps) => {
  const [value, setValue] = useState(currentFilter);
  const [searchTerm, setSearchTerm] = useState("");
  const ref = useRef<HTMLInputElement>(null);

  const filteredList = options.filter(option =>
    !searchTerm
      ? option
      : option.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleOnChange = (updatedValue: string, checked: boolean) => {
    const newValue = checked
      ? [...value, updatedValue]
      : value.filter(option => option !== updatedValue);
    setValue(newValue);
  };

  const selectedOption = (option: string) => currentFilter.includes(option);

  const handleSubmit = () => {
    const filterValue = value.filter(filter => !!filter).join(",");

    onChange(filterValue);
    closePopover();
  };

  useEffect(() => {
    ref.current?.focus();
  }, [ref]);

  return (
    <div className="react-multiselect-filter">
      <input
        type="text"
        ref={ref}
        className="form-control form-control--sm placeholder:text-light placeholder:opacity-100"
        onChange={e => setSearchTerm(e.target.value)}
        placeholder={t("members_directory.header.search.search")}
      />

      <div className="react-multiselect-filter__options">
        {filteredList.map((option, index) => (
          <div key={index} className="react-multiselect-filter__item">
            <div className="react-multiselect-filter__item-inner">
              <MultiSelectOption
                option={option}
                onChange={handleOnChange}
                selected={selectedOption(option.value.toString())}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-3">
        <Button variant="primary" onClick={handleSubmit}>
          {t("members_directory.header.search.apply_filter")}
        </Button>
      </div>
    </div>
  );
};
